import { render } from "./Question.vue?vue&type=template&id=8c6a698a&scoped=true"
import script from "./Question.vue?vue&type=script&lang=js"
export * from "./Question.vue?vue&type=script&lang=js"

import "./Question.vue?vue&type=style&index=0&id=8c6a698a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8c6a698a"

export default script